module.exports = __webpack_public_path__ + "img/zhili.541a7982.jpg";